const MagGlass = () => (
  <svg focusable={false} viewBox='0 0 24 24'>
    <path d='M16.162 15.102l5.618 5.618a.75.75 0 0 1-1.06 1.06l-5.618-5.618a8 8 0 1 1 1.06-1.06zM10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z' />
  </svg>
);

export default MagGlass;
